export function getDateFromObjectId(objectId: string) {
  // ObjectID's timestamp is the first 4 bytes
  // Convert the objectId to a hex string and then get the substring containing the timestamp
  const timestamp = objectId.toString().substring(0, 8);

  // Convert the timestamp from hex to an integer
  const timestampInt = parseInt(timestamp, 16);

  // Create a new Date object based on the timestamp in milliseconds
  return new Date(timestampInt * 1000).toLocaleString();
}

export function getCurrentDate(){
  const today = new Date();

  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();


  return `${year}-${month}-${day}`;
}

export function getDefaultDueDate() {
  const date = new Date();
  date.setDate(date.getDate() + 10);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

export function serializeDatePickerValue(date: Date): string {
  const normalized = new Date(date);
  normalized.setMinutes(normalized.getMinutes() - normalized.getTimezoneOffset());
  return normalized.toISOString();
}